import { Column } from 'react-table';
import { ContractStatusColumn, TextColumn } from 'shared/tables/columns';
import { ContractReviewGridItem } from 'shared/types';
import { ContractLinkColumn } from './contract-link-column';

export const customerContractTableColumns: Column<ContractReviewGridItem>[] = [
  {
    Header: 'Contract Name',
    accessor: 'originalDocumentName',
    Cell: ContractLinkColumn,
    align: 'center',
  },
  {
    Header: 'Customer',
    accessor: 'customerName',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Brand',
    accessor: 'brand',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Modified By',
    accessor: 'modifiedBy',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Modified Date',
    accessor: 'modifiedDate',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Approver',
    accessor: 'approvedBy',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Approval Date',
    accessor: 'approvedDate',
    Cell: TextColumn,
    align: 'left',
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ContractStatusColumn,
    align: 'left',
  },
];
